<template>
  <div class="tw-relative tw-w-full"
    :class="[
      {'tw-border-red-500': error},
      {'tw-mt-2 tw-mb-4': label || $slots.label},
      {'tw-border-green-500': valid === true},
      {'tw-border-red-500': valid === false}
    ]"
  >
    <slot name="label">
      <label v-if="label" class="tw-block tw-text-xs tw-font-medium tw-mb-1" :class="labelClasses">
        {{label}}
        <span v-if="required" class="tw-text-red-500">*</span>
      </label>
    </slot>

    <div class="tw-flex tw-items-center tw-bg-white-100 tw-border-solid tw-border-thin tw-border-gray-500 tw-rounded-lg tw-shadow-sm tw-overflow-auto">
      <div v-if="addonLeftIcon || $slots.addonLeft" class="tw-px-2" @click="addonLeftAction">
        <slot name="addonLeft">
          <i :class="addonLeftIcon" class="fas tw-text-gray-400"></i>
        </slot>
      </div>
      <slot v-bind="slotData">
        <input
          :value="value"
          v-on="listeners"
          v-bind="$attrs"
          class="tw-flex-1 tw-block tw-w-full tw-rounded-md tw-text-sm tw-bg-transparent tw-border-gray-300 focus:tw-bg-gray-100 focus:tw-border-primary-500 focus:tw-ring-primary-500"
          :class="[
              'tw-py-3 tw-px-4',
              'tw-border-none focus:tw-border-blue-500 focus:tw-ring-blue-500',
              {'tw-rounded-l-none': addonLeftIcon || $slots.addonLeft},
              {'tw-rounded-r-none': addonRightIcon || $slots.addonRight},
              {'tw-border-green-500 focus:tw-border-green-500 focus:tw-ring-green-500': valid === true},
              {'tw-border-red-500 focus:tw-border-red-500 focus:tw-ring-red-500': valid === false},
              inputClasses
          ]"
          aria-describedby="addon-right addon-left">
      </slot>
      <div v-if="addonRightIcon || $slots.addonRight" class="tw-px-2" @click="addonRightAction">
        <slot name="addonRight">
          <i :class="addonRightIcon" class="fas tw-text-gray-400"></i>
        </slot>
      </div>
    </div>

    <slot name="infoBlock"></slot>

    <slot name="helpBlock">
      <div v-if="error" 
        class="tw-mt-1 tw-text-sm tw-text-red-600"
        :class="{'tw-mt-2': hasIcon}">
        {{ error }}
      </div>
    </slot>
  </div>
</template>
<script>
export default {
  inheritAttrs: false,
  name: "tw-base-input",
  props: {
    required: {
      type: Boolean,
      description: "Whether input is required (adds an asterix *)"
    },
    valid: {
      type: Boolean,
      description: "Whether is valid",
      default: undefined
    },
    label: {
      type: String,
      description: "Input label (text before input)"
    },
    error: {
      type: String,
      description: "Input error (below input)"
    },
    labelClasses: {
      type: String,
      description: "Input label css classes"
    },
    inputClasses: {
      type: String,
      description: "Input css classes"
    },
    value: {
      type: [String, Number],
      description: "Input value"
    },
    addonRightIcon: {
      type: String,
      description: "Addon right icon"
    },
    addonLeftIcon: {
      type: String,
      description: "Addont left icon"
    },
    addonRightAction: {
      type: Function,
      description: "Addon right icon onclick function"
    },
    addonLeftAction: {
      type: Function,
      description: "Addont left icon onclick function"
    }
  },
  data() {
    return {
      focused: false
    };
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        input: this.updateValue,
        focus: this.onFocus,
        blur: this.onBlur
      };
    },
    slotData() {
      return {
        focused: this.focused,
        ...this.listeners
      };
    },
    hasIcon() {
      const { addonRight, addonLeft } = this.$slots;
      return (
        addonRight !== undefined ||
        addonLeft !== undefined ||
        this.addonRightIcon !== undefined ||
        this.addonLeftIcon !== undefined
      );
    }
  },
  methods: {
    updateValue(evt) {
      let value = evt.target.value;
      this.$emit("input", value);
    },
    onFocus(value) {
      this.focused = true;
      this.$emit("focus", value);
    },
    onBlur(value) {
      this.focused = false;
      this.$emit("blur", value);
    }
  }
};
</script>
<style>
</style>
